import React, { useState, useEffect } from "react";
import axios from "axios";

import { makeStyles } from "@material-ui/core/styles";
import { Spinner } from "react-bootstrap";
import { useAlert } from "react-alert";

import TabBar from "../components/tab-bar";

import {
  Grid,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Input,
  Button,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 620,
    backgroundColor: "white",
  },
  mainGrid: {
    width: 850,
    height: 450,
    backgroundColor: "#fff",
    textAlign: "center",
  },
}));

const Settings = () => {
  const alert = useAlert();
  const classes = useStyles();
  const [token, setToken] = useState("");
  const [success, setSuccess] = useState(false);
  const [resInfo] = useState(JSON.parse(localStorage.getItem("login")) || "");
  const [porsiyonName, setPorsiyonName] = useState("");
  const [resData, setResData] = useState([]);
  const [averagePtime, setAveragePtime] = useState(0);
  const [deliveryDuration, setDeliveryDuration] = useState(30);

  useEffect(() => {
    getToken();
    getState();
  }, []);

  useEffect(() => {
    fetchResInfo();
  }, [token]);

  const fetchResInfo = async () => {
    await axios
      .post(
        "https://getirs2.sambapos.com/restaurants",
        {},
        { headers: { token: token } }
      )
      .then((resp) => {
        setSuccess(true);
        setResData(resp.data);
        setAveragePtime(resp.data.averagePreparationTime);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getState = async () => {
    await axios
      .post("https://getirs2.sambapos.com/customers/state", {
        emailState: resInfo.email,
      })
      .then((resp) => {
        setPorsiyonName(resp.data.portion);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getToken = async () => {
    await axios
      .post("https://getirs2.sambapos.com/auth", {
        appsecretKey: resInfo.appsecretKey,
        restaurantsecretKey: resInfo.restaurantsecretKey,
      })
      .then((resp) => {
        setToken(resp.data.token);
      })
      .catch((err) => {
        alert.show(err.response.data.error);
      });
  };

  const averagePreparationTime = async (event) => {
    setAveragePtime(event.target.value);
    await axios
      .put(
        "https://getirs2.sambapos.com/restaurants/average-preparation-time",
        {
          averagePreparationTime: event.target.value,
        },
        { headers: { token: token } }
      )
      .then(() => {
        fetchResInfo();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /* const deliveryDurationFunc = async (e) => {
    console.log(token);
    setDeliveryDuration(e.target.value);
    await axios
      .put(
        "http://getircloud.sambapos.com:5000/restaurants/delivery-duration",
        {
          deliveryDuration: e.target.value,
        },
        { headers: { token: token } }
      )
      .then((resp) => {
        console.log(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  };*/

  const setPorsiyonNameFunc = async () => {
    await axios
      .post("https://getirs2.sambapos.com/restaurants/set-portion", {
        emailState: resInfo.email,
        portionName: porsiyonName,
      })
      .then((resp) => {
        setPorsiyonName(resp.data);
        alert.show("Kaydedildi");
        fetchResInfo();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div
      className="tab-content card pt-5"
      id="myTabContentMD"
      style={{ minHeight: 100 + "vh" }}
    >
      <TabBar
        item1={"Siparişler"}
        item1Route={"/order"}
        item2={"Menü Eşleştirme"}
        item2Route={"/menuchain"}
        pageName={"settings"}
      />

      <Grid className={classes.mainContainer}>
        {success === false ? (
          <Spinner
            animation="grow"
            role="status"
            style={{ width: 50, height: 50 }}
          ></Spinner>
        ) : (
          <Grid className={classes.mainGrid}>
            <Grid
              style={{
                textAlign: "center",
                marginLeft: 200,
                marginRight: 200,
                //backgroundColor: "aliceblue",
              }}
            >
              <Typography component={"p"}>
                Restoran Adı
                <Typography
                  component={"p"}
                  style={{ fontWeight: "bold", color: "red" }}
                >
                  {resData.name}
                </Typography>
              </Typography>
              <Typography component={"p"}>
                Restoran Durumu
                <Typography
                  component={"p"}
                  style={{ fontWeight: "bold", color: "red" }}
                >
                  {resData.status === 100 && "AÇIK"}
                  {resData.status === 300 && "KAPALI"}
                </Typography>
              </Typography>
            </Grid>
            <Grid
              style={{
                textAlign: "center",
                marginTop: 30,
                marginLeft: 200,
                marginRight: 200,
                flexDirection: "column",
                display: "flex",
              }}
            >
              <Typography style={{ fontWeight: "bold" }} component={"span"}>
                Porsiyon Özelliği :{" "}
                <Input
                  style={{ textAlignLast: "center", width: 100 }}
                  value={porsiyonName}
                  onChange={(e) => setPorsiyonName(e.target.value)}
                ></Input>
              </Typography>
            </Grid>
            <Grid
              style={{
                textAlign: "center",
                marginTop: 30,
                marginLeft: 200,
                marginRight: 200,
              }}
            >
              <FormControl component="fieldset" style={{ textAlign: "center" }}>
                <FormLabel component="legend" style={{ fontWeight: "bold" }}>
                  Sipariş Hazırlama Süresi
                </FormLabel>
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  style={{ flexDirection: "row" }}
                  value={averagePtime}
                  onChange={(event) => averagePreparationTime(event)}
                >
                  <FormControlLabel
                    value={30}
                    control={<Radio />}
                    label="30 dk"
                  />
                  <FormControlLabel
                    value={35}
                    control={<Radio />}
                    label="35 dk"
                  />
                  <FormControlLabel
                    value={40}
                    control={<Radio />}
                    label="40 dk"
                  />
                  <FormControlLabel
                    value={45}
                    control={<Radio />}
                    label="45 dk"
                  />
                  <FormControlLabel
                    value={50}
                    control={<Radio />}
                    label="50 dk"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid style={{ textAlign: "center", marginTop: 20 }}>
              <FormControl component="fieldset" style={{ textAlign: "center" }}>
                <FormLabel component="legend" style={{ fontWeight: "bold" }}>
                  Tahmini Teslim Süresi
                </FormLabel>
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  style={{ flexDirection: "row" }}
                  value={deliveryDuration}
                  // onChange={(e) => console.log("2")}
                >
                  <FormControlLabel
                    value={30}
                    control={<Radio />}
                    label="30 dk"
                  />
                  <FormControlLabel
                    value={35}
                    control={<Radio />}
                    label="35 dk"
                  />
                  <FormControlLabel
                    value={40}
                    control={<Radio />}
                    label="40 dk"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Button
              className="btn-blue"
              onClick={() => setPorsiyonNameFunc()}
              style={{ width: 200, color: "white" }}
            >
              KAYDET
            </Button>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default Settings;
